import * as moment from 'moment';

let id: number = 0;

async function getAttendance(
  startTime: Date,
  endTime: Date,
  siteId: string,
  detections: Detection[],
  timezone: string
): Promise<{
  entries: (TimeEntry & { startTime: number, endTime: number })[];
  startTime: Date,
  endTime: Date,
  siteId: string,
}> {
  try {
    const tz = timezone && timezone.includes(' ') ? timezone.split(' ')[0] : "UTC";

    const data: { id: number, workerId: number, siteId: string, startTime: number, endTime: number }[] = [];

    const map = new Map<number, Detection[]>();

    detections.forEach((el) => {
      if (!map.has(el.workerId)) {
        map.set(el.workerId, [el])
      } else {
        map.set(el.workerId, [...map.get(el.workerId) || [], el])
      }
    });

    map.forEach((value, key) => {
      var m = moment.tz(startTime.getTime(), tz);
      var start = m.clone().startOf('day').utc().format();
      var end = m.clone().endOf('day').utc().format();

      while (end < endTime.toISOString()) {
        // eslint-disable-next-line no-loop-func
        let dayDetections = value.filter(el => {
          return moment.tz(el.detectionTimestamp, tz).format() > start && moment.tz(el.detectionTimestamp, tz).format() < end
        });

        for (let i = 0; i < dayDetections.length; i += 1) {
          const out = dayDetections.find((el, index) => index > i && el.direction === "OUT");

          if (out) {
            id += 1;
            data.push({
              id: id,
              startTime: moment.tz(new Date(dayDetections[i].detectionTimestamp).getTime(), tz).toDate().getTime(),
              endTime: moment.tz(new Date(out.detectionTimestamp).getTime(), tz).toDate().getTime(),
              workerId: key,
              siteId
            });
            i = dayDetections.indexOf(out) + 1;
          } else {
            id += 1;
            data.push({
              id: id,
              startTime: moment.tz(new Date(dayDetections[i].detectionTimestamp).getTime(), tz).toDate().getTime(),
              endTime: moment.tz(new Date(dayDetections[dayDetections.length - 1].detectionTimestamp).getTime(), tz).toDate().getTime(),
              workerId: key,
              siteId
            });
            break;
          }
        }

        start = end;
        end = moment.tz(start, tz).add(24, 'hours').format();
      }
    });

    return {
      entries: data as any[],
      startTime,
      endTime,
      siteId
    };
  } catch (error: any) {
    throw error;
  }
}

export default getAttendance;
